// Authors: Delaney Gillilan
// Icon: material-symbols:toggle-off
// Slug: Toggle all signals that match the signal path
// Description: Toggle all signals that match one or more space-separated paths in which `*` can be used as a wildcard

import type { ActionPlugin, RuntimeContext } from '../../../engine/types'
import { updateLeaves } from '../../../utils/paths'

export const ToggleAll: ActionPlugin = {
  type: 'action',
  name: 'toggleAll',
  fn: ({ merge, filtered }: RuntimeContext, include: string) => {
    const masked = filtered({ include })
    updateLeaves(masked, (oldValue: any) => !oldValue)
    merge(masked)
  },
}
